import { render, staticRenderFns } from "./CursoAdd.vue?vue&type=template&id=5bf95894&"
import script from "./CursoAdd.vue?vue&type=script&lang=js&"
export * from "./CursoAdd.vue?vue&type=script&lang=js&"
import style0 from "./CursoAdd.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports